import React, { useState } from 'react'
import { useNavigate } from 'react-router'
import cx from 'classnames'
import { useAppSelector } from '../../../hooks/useStore'
import FocusableButtonTS from '../../FocusableButton/FocusableButtonTS'
import { MoreEpisodesIcon } from '../../Icons'
import { ContentActionButtonFocusKeys, ContentActionButtonLabel } from './types'
import type { ButtonProps } from '../types'

function MoreEpisodes(props: ButtonProps) {
  const [isFocused, setIsFocused] = useState(false)
  const navigate = useNavigate()
  const content = useAppSelector((state) => state.content)
  const videoDetails = content.videoDetails

  let onPressAction: () => void = () => {}
  if (videoDetails.parent?.resource_type !== 'franchise') {
    const parentItemUrl = `/show-details/${videoDetails.parentShowSlug}`
    onPressAction = () => {
      navigate(parentItemUrl)
      props.onPress(ContentActionButtonLabel.MORE_EPISODES)
    }
  }

  const onFocus = () => {
    setIsFocused(true)
    props.onFocus({
      label: ContentActionButtonLabel.MORE_EPISODES,
    })
  }

  const onBlur = () => {
    setIsFocused(false)
  }

  if (videoDetails.parent?.resource_type === 'franchise') {
    return <></>
  }
  return (
    <div className="video-detail-screen__control-button">
      <FocusableButtonTS
        focusKey={ContentActionButtonFocusKeys.MORE_EPISODES}
        onEnterPress={onPressAction}
        onArrowPress={props.onArrowPress}
        onFocus={onFocus}
        onBlur={onBlur}
      >
        <MoreEpisodesIcon />
      </FocusableButtonTS>
      <span
        className={cx('video-detail-screen__control-button-label', {
          'video-detail-screen__control-button-label--focused': isFocused,
        })}
      >
        {ContentActionButtonLabel.MORE_EPISODES}
      </span>
    </div>
  )
}

export default MoreEpisodes
